import { ValidationErrorResponse } from "../../../services/ValidationError";
import { ServicioHotel } from "../../../services/hotelServicios";
import {parseCurrency} from "../../../utils/numberUtils";

export interface FormValue {
    wasTouched: boolean,
    isValid: boolean | undefined
}

export interface TextFormValue extends FormValue {
    value: string
}

export interface FormState {
    nombre: TextFormValue,
    descripcion: TextFormValue,
    precioNoche: TextFormValue,
    horaSalida: TextFormValue,
    minimoNoches: TextFormValue,
    maximoNoches: TextFormValue,
}

export const initialFormState: FormState = {
    nombre: { value: "", wasTouched: false, isValid: undefined },
    descripcion: { value: "", wasTouched: false, isValid: undefined },
    precioNoche: { value: "0", wasTouched: false, isValid: undefined },
    horaSalida: { value: "11", wasTouched: true, isValid: undefined },
    minimoNoches: { value: "", wasTouched: false, isValid: undefined },
    maximoNoches: { value: "", wasTouched: false, isValid: undefined },
}

export const resetValidStates = (formState: FormState) => {
    Object.keys(formState).forEach(_key => {
        const currentVal: FormValue = (formState as any)[_key] as FormValue;
        (formState as any)[_key] = { ...currentVal, isValid: undefined };
    });
}

export const invalidateStates = (formState: FormState, validationErrorResponse: ValidationErrorResponse) => {
    Object.keys(validationErrorResponse).forEach(errKey => {
        const errKeyStr = errKey as string;
        const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
        (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
    })
}

export const servicioHotelAFormState = (servicio: ServicioHotel): FormState => {
    return {
        nombre: {value: servicio?.nombre || '', wasTouched: false, isValid: undefined},
        descripcion: {value: servicio?.descripcion || '', wasTouched: false, isValid: undefined},
        maximoNoches: {value: servicio?.maximoNoches?.toString() || '', wasTouched: false, isValid: undefined},
        minimoNoches: {value: servicio?.minimoNoches?.toString() || '', wasTouched: false, isValid: undefined},
        precioNoche: {value: servicio?.precioNoche.toString() || '', wasTouched: false, isValid: undefined},
        horaSalida: {value: servicio?.horaSalida?.toString() || '', wasTouched: false, isValid: undefined},
    };
}

export const formStateAServicioHotel = (id: string, formState: FormState): ServicioHotel => {
    return {
        id,
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.value,
        maximoNoches: formState.maximoNoches.value ? Number.parseInt(formState.maximoNoches.value) : undefined,
        minimoNoches: formState.minimoNoches.value ? Number.parseInt(formState.minimoNoches.value) : undefined,
        horaSalida: formState.horaSalida.value ? Number.parseInt(formState.horaSalida.value) : undefined,
        precioNoche: parseCurrency(formState.precioNoche.value, "$", ","),
    }
}